import type moment from "moment";
import { type Segment, type SegmentErrors } from "./model";

export const isDepartureTooEarly = (departure: moment.Moment, arrival: moment.Moment): boolean => arrival.diff(departure, "hours") < -36;

export const validateSegment = (segment: Segment) => {
  let noDepartureAirportError = false;
  let noArrivalAirportError = false;
  let noAirlineError = false;
  let noFlightCodeError = false;
  let noFlightNumberError = false;
  const departureTooEarly = isDepartureTooEarly(segment.props.departure, segment.props.arrival);

  noDepartureAirportError = segment.props.departureAirport == null;
  noArrivalAirportError = segment.props.arrivalAirport == null;

  if (segment.type === "commercial") {
    noAirlineError = segment.props.airline == null;
    noFlightCodeError = segment.props.flightCode.trim() === "";
    noFlightNumberError = segment.props.flightNumber.trim() === "";
  }

  const errors: SegmentErrors = {
    noDepartureAirportError,
    noArrivalAirportError,
    noAirlineError,
    noFlightCodeError,
    noFlightNumberError,
    departureTooEarly
  };

  const anyErrors = () => Object.values(errors).some(e => e === true);

  return {
    anyErrors,
    errors
  };
};
